/**
 * Interceptor HTTP: registra mutaciones relevantes en auditoría (sin el batch de auditoría).
 */
import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs/operators';
import { AuditoriaService } from '../auditoria/auditoria.service';
import { resolveApiErrorMessage } from '../http/resolve-http-error-message';

const MUTATION_METHODS = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);

export const auditoriaInterceptor: HttpInterceptorFn = (req, next) => {
  const auditoria = inject(AuditoriaService);
  const shouldAudit =
    MUTATION_METHODS.has(req.method) && !req.url.includes('/auditoria/eventos/batch');

  if (!shouldAudit) {
    return next(req);
  }

  return next(req).pipe(
    tap({
      next: (event) => {
        if (event instanceof HttpResponse) {
          auditoria.trackApiMutation(req.method, req.url, event.status, 'OK');
        }
      },
      error: (error: unknown) => {
        const status =
          typeof error === 'object' && error !== null && 'status' in error
            ? Number((error as { status?: number }).status) || 0
            : 0;
        const message = resolveApiErrorMessage(
          error,
          'Error en la operación. Intente de nuevo o contacte al administrador.',
        );
        auditoria.trackApiMutation(req.method, req.url, status, 'ERROR', message);
      },
    }),
  );
};
